<template>
  <div id="main-content" class="student-list">
    <el-row>
      <el-col :offset="1" :span="22">
        <PageTitle :title="title" :backLink="backLink"></PageTitle>
        <el-form :inline="true" class="demo-form-inline">
          <el-form-item>
            <div class="d-flex">
              <div class="text-label-password">{{$t('fileM.passwordDefault')}}</div>
              <el-input v-model="defaultPassword" show-password></el-input>
              <el-button @click="onUpdateDefaultPassword" type="primary ml-2">{{ $t('common.save') }}</el-button>
            </div>
          </el-form-item>
          <el-form-item>
            <el-button type="success" @click="onAddCategory">+ {{ $t('categoryM.add_category') }}</el-button>
          </el-form-item>
        </el-form>
        <el-row>
          <el-col :span="24">
            <table class="bus-list mt-4">
              <tr>
                <th width="5%"></th>
                <th width="5%">#</th>
                <th width="20%">
                  <div class="d-flex justify-center">
                    <span>{{ $t('categoryM.name') }}</span>
                    <Sort :model="sort.name" @change="changeSort($event, 'name')"></Sort>
                  </div>
                </th>
                <th width="20%">{{ $t('categoryM.note') }}</th>
                <th width="15%">
                  <div class="d-flex justify-center">
                    <span>{{ $t('categoryM.created_at') }}</span>
                    <Sort :model="sort.created_at" @change="changeSort($event, 'created_at')"></Sort>
                  </div>

                </th>
                <th width="15%">
                  <div class="d-flex justify-center">
                    <span>{{ $t('categoryM.updated_at') }}</span>
                    <Sort :model="sort.updated_at" @change="changeSort($event, 'updated_at')"></Sort>
                  </div>
                </th>
                <th></th>
              </tr>
              <draggable v-model="list" tag="tbody"   @end="swapCaterories">
                <tr v-for="(item, index) in list" :key="index">
                  <td scope="row" width="5%">
                    <i class="el-icon-rank"></i>
                  </td>
                  <td scope="row" width="5%">{{index+1}}</td>
                  <td>{{item.name}}</td>
                  <td>{{item.note}}</td>
                  <td>{{item.created_at ? formatDateTime('YYYY/MM/DD HH:mm:ss', item.created_at) : ''}}</td>
                  <td>{{item.updated_at ? formatDateTime('YYYY/MM/DD HH:mm:ss', item.updated_at) : ''}}</td>
                  <td>
                    <div>
                      <b-button variant="outline-primary" class="mr-2" @click="onEdit(item.id)">{{ $t('common.detail') }}</b-button>
                      <b-button  variant="danger" class="mr-2" @click="onDelete(item.id)">{{ $t('common.delete') }}</b-button>
                      <b-button v-if="item.is_disable ===0"   variant="warning"  @click="onDisabled(item)">{{ $t('common.disable') }}</b-button>
                      <b-button v-else variant="primary"   @click="onDisabled(item)">{{ $t('common.enable') }}</b-button>
                    </div>
                  </td>
                </tr>
              </draggable>
            </table>
          </el-col>
        </el-row>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import PageTitle from "@/components/PageTitle";
import draggable from 'vuedraggable'
import Sort from "@/components/Sort";
import {formatDateTime} from '@/utils'
export default {
  components:{
    PageTitle,
    draggable,
    Sort
  },
  data(){
    return {
      title:'categoryM.titleList',
      backLink: ``,
      listCategory: [],
      filter:{
        name:'',
        title: ''
      },
      sort: {
        name: null,
        created_at: null,
        updated_at:null
      },
      list: [],
      listDataNotChange : [],
      defaultPassword: null,
      errorPassword: ''
    }
  },
  created() {
    this.onGetListCaterories()
    this.onGetDefaultPassword()
  },
  methods:{
    onValidatePassword(){
      let check = true
      if(this.defaultPassword ===null || (this.defaultPassword && this.defaultPassword.trim()==='')){
        check = false
        this.errorPassword= this.$t('msg.required', {field: this.$t('fileM.passwordDefault')})
      } else{
        this.errorPassword= ""
      }
      if(this.defaultPassword.length>32 || this.defaultPassword.length<6){
        check = false
        this.errorPassword= this.$t('passwordBetween')
      }else{
        this.errorPassword= ""
      }
      return check
    },
    onGetDefaultPassword(){

      let successCallback = (res) =>{
        if(res.status ===200){
          this.defaultPassword = res.data.data.password_default
        }
      }
      let errorCallback = () => {}

      let payload ={
        errorCallback,
        successCallback
      }
      this.$store.dispatch('CategoriesFile/getPasswordDefault', payload)

    },
    onUpdateDefaultPassword(){
      let successCallback = (res) =>{
        if(res.status ===200){
          this.$notify({
            title: this.$t('msg.titleSuccess'),
            message: this.$t('msg.contentUpdateSuccess', { field: this.$t('fileM.passwordDefault') }),
            type: 'success'
          })
        }
      }
      let errorCallback = () => {}

      let payload ={
        errorCallback,
        successCallback,
        data: {
          password: this.defaultPassword
        }
      }
      let check = this.onValidatePassword()
      if(check){
        this.$store.dispatch('CategoriesFile/updatePasswordDefault', payload)
      }else{
        this.$store.commit('openNotification', {
          type: 'error',
          message:  this.errorPassword
        })
      }
    },
    onDelete(id){
      let payload = {
        successCallback: (response) => {
          if(response.status ===200){
            this.onGetListCaterories()
            this.$notify({
              title: this.$t('msg.titleSuccess'),
              message: this.$t('msg.contentDeleteSuccess', { field: this.$t('nameField.category') }),
              type: 'success'
            })
          }
        },
        errorCallback: () => {},
        category_id: id
      }
      this.$store.commit('openConfirm', {
        title: this.$t('common.delete'),
        message: this.$t('msg.deleteConfirm', {field: this.$t('nameField.category')}),
        callback: () => {
          this.$store.dispatch('CategoriesFile/deleteCategory', payload)
        }
      })
    },
    onDisabled(item){
      let payload = {
        successCallback: (response) => {
          if(response.status ===200){
            this.onGetListCaterories()
            this.$notify({
              title: this.$t('msg.titleSuccess'),
              message: item.is_disable ? this.$t('msg.contentEnableSuccess', { field: this.$t('nameField.category') }) : this.$t('msg.contentDisableSuccess', { field: this.$t('nameField.category') }),
              type: 'success'
            })
          }
        },
        errorCallback: () => {},
        category_id:item.id
      }
      this.$store.commit('openConfirm', {
        title: item.is_disable ? this.$t('common.enable') : this.$t('common.disable'),
        message: item.is_disable ? this.$t('msg.enableMessage', {field: this.$t('nameField.category')}) :  this.$t('msg.disableMessage', {field: this.$t('nameField.category')}),
        callback: () => {
          this.$store.dispatch('CategoriesFile/disableCategory', payload)
        }
      })
    },
    onEdit(id){
      this.$router.push({name: 'category-management-id', params:{id: id}})
   },
    formatDateTime(param, value){
      return formatDateTime(param, value)
    },
    onAddCategory(){
      this.$router.push('/category-management-create')
    },
    changeSort (type, field) {
      this.sort[field] = type
      this.sort = Object.assign({}, this.sort)
      this.onGetListCaterories()
    },
    onGetListCaterories(){
      let payload = {
        successCallback: (response) => {
          if(response.status ===200){
            this.list = response.data.data.data_list
            this.listDataNotChange = response.data.data.data_list
          }
        },
        errorCallback: () => {},
        sort: this.sort
      }
      this.$store.dispatch('CategoriesFile/getListCategory', payload)
    },
    swapCaterories(e){
      let data = {}
      let oldIndex = parseInt(e.oldIndex) || 0
      let newIndex = parseInt(e.newIndex) || 0
      if(oldIndex !== newIndex){
        data.drag = this.listDataNotChange[oldIndex].id
        data.drop = this.listDataNotChange[newIndex].id
      }
      let payload = {
        successCallback: (response) => {
          if(response.status ===200){
            this.onGetListCaterories()
          }
        },
        errorCallback: () => {},
        data:data
      }
      if(data.drag> -1 && data.drop>-1){
        this.$store.dispatch('CategoriesFile/swapCategory', payload)
      }

    }
  }
}
</script>
<style lang="scss">
.justify-center{
  justify-content: center;
}
.el-notification{
  top:110px !important;
}
.text-label-password{
  white-space: nowrap;
  font-size: 1rem;
  font-weight: bold;
  margin-right: .5rem;
}
</style>
